/**
 * Deletes given item, if found, returning newState if deleted else original state
 * @param idKey
 * @param items
 * @param newItem
 */
export const deleteItem = <
  TData extends Record<TIdKey, any>,
  TIdKey extends keyof TData = keyof TData
>(
  idKey: TIdKey,
  items: TData[],
  idToDelete: TData[TIdKey],
): TData[] => {
  const newItems = items.filter(d => d[idKey] !== idToDelete);

  return newItems.length === items.length ? items : newItems;
};
